define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/CustomerCoordinatorModel", "../../models/UserContext", "../../shared/dataLogs", "../../utils/LookupDataSources", "../../models/ManagerDeleteModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, CustomerCoordinatorModel, UserContext, DataLogs, LookupDataSources, ManagerDeleteModel) {
    "use strict";
    var CustomerCoordinators = /** @class */ (function () {
        function CustomerCoordinators() {
            this.editModel = ko.observable(new CustomerCoordinatorModel());
            this.deleteManagerModel = ko.observable(new ManagerDeleteModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        CustomerCoordinators.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customer Coordinators");
            tools.ajaxGet({
                url: "/CustomerCoordinator/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initCoordinators(self.lookupLists.GridStructures.CoordinatorsStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerCoordinators.prototype.initCoordinators = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "80px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    html += '<div style="text-align:center"><a class="btn btn-info btn-edit btn-sm" title="Edit" href="#"><i class="fa fa-edit " ></i></a>';
                    html += '&nbsp;<a class="btn btn-danger btn-remove btn-sm" title="Delete" href="#"><i class="fa fa-trash-o"></i></a></div>';
                    return html;
                }
            });
            var gridId = "coordinatorsTable";
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                    //toolbar: kendo.template($("#product-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerCoordinator/GetCoordinators",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CustomerCoordinator",
                    title: "Customer Coordinators",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.mainTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCoordinator(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteCoordinatorConfirm(data.Id, data.Coordinator);
                event.preventDefault();
            });
        };
        CustomerCoordinators.prototype.editCoordinator = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Coordinator" : "Add Coordinator";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().CustomerId(self.customerDropDown.value());
                    //validate form
                    if (!self.editModel().CustomerId()) {
                        tools.error("Customer is required");
                        return;
                    }
                    if (!self.editModel().Coordinator()) {
                        tools.error("Coordinator is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCoordinator(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerCoordinator/GetCoordinatorById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerCoordinatorModel(result.Data));
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerCoordinatorModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'coordinator-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var dataSource = lookupDataSources.createLookupDataSource("Customers");
                        self.customerDropDown = $("input[name=CustomerId]", modal).kendoDropDownList({
                            dataSource: dataSource,
                            optionLabel: "Select Customer",
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: modal
                            }
                        }).data("kendoDropDownList");
                        self.customerDropDown.value(self.editModel().CustomerId());
                    });
                }
            });
        };
        CustomerCoordinators.prototype.saveCoordinator = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerCoordinator/SaveCoordinator",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.mainTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerCoordinators.prototype.deleteCoordinatorConfirm = function (id, coordinator) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Coordinator",
                text: 'Are you sure you want to delete customer coordinator "' + coordinator + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerCoordinator(id);
            });
        };
        CustomerCoordinators.prototype.deleteCustomerCoordinator = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerCoordinator/DeleteConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Coordinator deleted successfully");
                    self.mainTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerCoordinators.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        CustomerCoordinators.prototype.exportTo = function () {
            var self = this;
            self.mainTable.exportTo();
        };
        CustomerCoordinators.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CustomerCoordinator");
                dataLogs.open("Customer Coordinator logs");
                event.preventDefault();
            }
        };
        CustomerCoordinators.prototype.showApiLogs = function () {
            /*if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CustomerCoordinator");
                dataLogs.open("Customer Coordinator logs");
                event.preventDefault();
            }*/
        };
        return CustomerCoordinators;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CustomerCoordinator/Index")) {
            log.log("Initialize Customer Coordinators");
            $(function () {
                (new CustomerCoordinators()).init();
            });
        }
    }, 0);
    return CustomerCoordinators;
});
//# sourceMappingURL=customerCoordinators.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerCoordinator/customerCoordinators.js
// module id = 270
// module chunks = 2